import {Singleton} from 'annotation';
import environment from 'environment';

import ProxyService from './Proxy';

import EntityAware from '../entity/EntityAware';
import PosPembayaran from "../entity/PosPembayaran";

@Singleton
export default class PosPembayaranService extends ProxyService {

    public api: string = environment.POS_PEMBAYARAN_API;   // define api url to fetch data

    public serializer: EntityAware = PosPembayaran;

}
